import { useState, useEffect } from "react";
import { GET_FAQS } from "../api/constants";

export const useFAQS = () => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    

    const fetchFAQs = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await fetch(GET_FAQS);
        
        const data = await response.json();

        if (data.status) {
          setFaqs(data.data || null);
        } else {
          setFaqs(null);
          setError(data.message || "FAQs not found.");
        }
      } catch (err) {
        console.error("Error fetching FAQs:", err);
        setError("Failed to fetch FAQs.");
      } finally {
        setLoading(false);
      }
    };

    fetchFAQs();
  }, []);

  return { faqs, loading, error };
};
